/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Template
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Configuration for speaker diarization
 * @export
 * @interface BatchTranscriptionConfigSpeakerDiarizationConfig
 */
export interface BatchTranscriptionConfigSpeakerDiarizationConfig {
  /**
   * Controls how sensitive the algorithm is in terms of keeping similar speakers separate, as opposed to combining them into a single speaker.  Higher values will typically lead to more speakers, as the degree of difference between speakers in order to allow them to remain distinct will be lower.  A lower value for this parameter will conversely guide the algorithm towards being less sensitive in terms of retaining similar speakers, and as such may lead to fewer speakers overall.  The default is 0.5.
   * @type {number}
   * @memberof BatchTranscriptionConfigSpeakerDiarizationConfig
   */
  speaker_sensitivity?: number;
}
